<template>
  <AccountantsSubmenu
    :items="menuItems"
  >
    <template v-slot:titletop>
      <!-- <div class="submenu-title">
        {{ $gettext('Settings') }}
      </div> -->
    </template>
  </AccountantsSubmenu>
</template>

<script>
import AccountantsSubmenu from '@/components/accountants/AccountantsSubmenu.vue'

export default {
  name: 'AccountantsSettingsMenu',
  components: { AccountantsSubmenu },
  computed: {
    menuItems() {
      return [
        {
          key: 'company-details',
          label: this.$gettext('Company details'),
          name: 'AccountantCompanySettings',
          icon: 'fa-briefcase',
        },
        {
          key: 'personal-profile',
          label: this.$gettext('Personal profile'),
          name: 'AccountantProfileSettings',
          icon: 'fa-gear',
        },
        {
          key: 'change-password',
          label: this.$gettext('Change password'),
          name: 'AccountantProfileChangePassword',
          icon: 'fa-lock',
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
</style>
